import { OverflowTooltip, OverflowTooltipProps } from 'components';
import React from 'react';
import { ComponentBaseProps } from 'types';

type StatusBoxProps = {
  value: string;
  maxSize?: number;
} & ComponentBaseProps &
  Pick<OverflowTooltipProps, 'prefix'>;

export const StatusBox = ({
  value,
  prefix,
  className = '',
  style,
  maxSize = 21,
}: StatusBoxProps) => {
  return (
    <div
      style={style}
      className={`text-wfBlack border min-w-fit w-16 rounded px-2  ${className}`}
    >
      <OverflowTooltip
        text={value}
        prefix={prefix}
        maxSize={maxSize}
        className='flex items-center'
      />
    </div>
  );
};
